// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Context = require("../../../../provider/Context.bs.js");
var Atom_Box = require("../../../atom/Atom_Box.bs.js");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Cell = require("../../../atom/Atom_Cell.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Atom_Column = require("../../../atom/Atom_Column.bs.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../../../../type/Type_Common.bs.js");
var Atom_Divider = require("../../../atom/Atom_Divider.bs.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../../particle/Particle_Spacer_Ds.bs.js");
var Organism_Header_Css = require("../Organism_Header_Css.bs.js");
var Organism_SettingsMenu = require("../Organism_SettingsMenu.bs.js");
var Particle_Background_Ds = require("../../../particle/Particle_Background_Ds.bs.js");
var Organism_Concert_SocialLinks = require("./Organism_Concert_SocialLinks.bs.js");

var linkBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("S"));

var guideBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.make("XXS", "XS", "None", "None", undefined));

var otherLinkBlockspace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("XS"));

var linkSpacer = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("XS"));

var linkDirection = Particle_Screen_Ds.make(undefined, undefined, "row", undefined, undefined, "column");

function getLinksByKind(links, kind) {
  return Belt_Array.keep(links, (function (link) {
                return link.kind === kind;
              }));
}

function Organism_ConcertMenuNavigation(Props) {
  var links = Props.links;
  var state = Props.state;
  var socialNetworks = Props.socialNetworks;
  var selectGenre = Props.selectGenre;
  var ref_ = Props.ref_;
  var ffNewConcertHeader = Context.Config.getFeatureFlippingStatus(/* NewConcertHeader */11);
  var preferenceLinks = getLinksByKind(links, Type_Common.linkKindToJs("preference"));
  var otherLinks = ffNewConcertHeader ? getLinksByKind(links, Type_Common.linkKindToJs("other")) : Belt_Array.keep(links, (function (link) {
            return link.id === "guide";
          }));
  var rules = Organism_Header_Css.ConcertMenuNavigation.makeRules(ffNewConcertHeader);
  if (state) {
    return null;
  }
  var tmp = {
    background: Particle_Background_Ds.dropdownMenu,
    blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S")),
    children: ffNewConcertHeader ? (
        preferenceLinks.length !== 0 ? React.createElement(React.Fragment, undefined, React.createElement(Atom_Box.make, {
                    children: Belt_Array.map(preferenceLinks, (function (param) {
                            var href = param.href;
                            return React.createElement(Atom_Cta.Link.make, {
                                        href: href,
                                        label: param.label,
                                        style: {
                                          TAG: /* Header */10,
                                          _0: {
                                            TAG: /* MenuNavigation */8,
                                            _0: /* Inactive */1
                                          }
                                        },
                                        key: href
                                      });
                          })),
                    direction: linkDirection,
                    spacer: linkSpacer
                  }), React.createElement(Atom_Divider.make, {
                    style: Atom_Divider.menuNavigation
                  }), React.createElement(Atom_Box.make, {
                    children: null,
                    direction: linkDirection,
                    spacer: linkSpacer
                  }, Belt_Array.map(otherLinks, (function (param) {
                          var href = param.href;
                          return React.createElement(Atom_Cta.Link.make, {
                                      href: href,
                                      label: param.label,
                                      style: {
                                        TAG: /* Header */10,
                                        _0: {
                                          TAG: /* MenuNavigation */8,
                                          _0: /* Inactive */1
                                        }
                                      },
                                      key: href
                                    });
                        })), React.createElement(Organism_SettingsMenu.Link.make, {}))) : null
      ) : React.createElement(React.Fragment, undefined, React.createElement(Atom_Column.make, {
                blockSpace: linkSpacer,
                children: null
              }, React.createElement(Atom_Cell.make, {
                    blockSpace: linkBlockSpace,
                    children: React.createElement(Atom_Cta.Link.make, {
                          href: selectGenre.title.href,
                          label: selectGenre.title.label,
                          style: {
                            TAG: /* Header */10,
                            _0: {
                              TAG: /* ConcertMenuNavigation */16,
                              _0: ffNewConcertHeader
                            }
                          },
                          key: selectGenre.title.href
                        })
                  }), Belt_Array.map(selectGenre.items, (function (param) {
                      var href = param.href;
                      return React.createElement(Atom_Cell.make, {
                                  blockSpace: linkBlockSpace,
                                  children: React.createElement(Atom_Cta.Link.make, {
                                        href: href,
                                        label: param.label,
                                        style: {
                                          TAG: /* Header */10,
                                          _0: /* GenreItem */5
                                        },
                                        key: href
                                      })
                                });
                    }))), React.createElement(Atom_Column.make, {
                blockSpace: otherLinkBlockspace,
                children: null
              }, Belt_Array.map(otherLinks, (function (param) {
                      var href = param.href;
                      return React.createElement(Atom_Cell.make, {
                                  blockSpace: guideBlockSpace,
                                  children: React.createElement(Atom_Cta.Link.make, {
                                        href: href,
                                        label: param.label,
                                        style: {
                                          TAG: /* Header */10,
                                          _0: {
                                            TAG: /* ConcertMenuNavigation */16,
                                            _0: ffNewConcertHeader
                                          }
                                        },
                                        key: href
                                      })
                                });
                    })), React.createElement(Atom_Cell.make, {
                    blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("S")),
                    children: React.createElement(Organism_Concert_SocialLinks.make, {
                          socialNetworks: socialNetworks
                        })
                  }))),
    rules: rules
  };
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Column.make, tmp);
}

var make = Organism_ConcertMenuNavigation;

exports.linkBlockSpace = linkBlockSpace;
exports.guideBlockSpace = guideBlockSpace;
exports.otherLinkBlockspace = otherLinkBlockspace;
exports.linkSpacer = linkSpacer;
exports.linkDirection = linkDirection;
exports.getLinksByKind = getLinksByKind;
exports.make = make;
/* linkBlockSpace Not a pure module */
